import { render, staticRenderFns } from "./LatestOfficialResult.vue?vue&type=template&id=1b8e3478&scoped=true&"
import script from "./LatestOfficialResult.vue?vue&type=script&lang=js&"
export * from "./LatestOfficialResult.vue?vue&type=script&lang=js&"
import style0 from "./LatestOfficialResult.vue?vue&type=style&index=0&id=1b8e3478&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8e3478",
  null
  
)

export default component.exports